import { render, staticRenderFns } from "./ScopeServiceForm.vue?vue&type=template&id=943a8976&"
import script from "./ScopeServiceForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ScopeServiceForm.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports